import * as Model from "@effect/sql/Model";
import { Schema } from "effect";

/**
 * Subscription plan types.
 * - weekly: 7-day subscription
 * - monthly: 30-day subscription
 * - annual: 365-day subscription
 */
export const SubscriptionPlan = Schema.Literal("weekly", "monthly", "annual");
export type SubscriptionPlan = Schema.Schema.Type<typeof SubscriptionPlan>;

/**
 * Subscription status types.
 * - active: Subscription is current and paid
 * - canceled: User canceled but may still have access until period end
 * - expired: Subscription ended
 * - past_due: Payment failed, pending retry
 */
export const SubscriptionStatus = Schema.Literal("active", "canceled", "expired", "past_due");
export type SubscriptionStatus = Schema.Schema.Type<typeof SubscriptionStatus>;

/**
 * Subscription model representing a customer's payment subscription.
 *
 * Integrates with:
 * - Stripe: Primary payment processor (stripeSubscriptionId on the subscription;
 *   stripeCustomerId lives on the customer entity)
 * - RevenueCat: Mobile entitlement sync (revenuecatAppUserId)
 *
 * @since 1.0.0
 */
export class Subscription extends Model.Class<Subscription>("Subscription")({
  id: Model.Generated(Schema.String),
  customerId: Schema.String,
  installationId: Schema.NullOr(Schema.String),

  stripeSubscriptionId: Schema.NullOr(Schema.String),
  revenuecatAppUserId: Schema.NullOr(Schema.String),

  plan: SubscriptionPlan,
  status: SubscriptionStatus,
  amount: Schema.NullOr(Schema.Number),

  currentPeriodStart: Schema.NullOr(Schema.DateTimeUtc),
  currentPeriodEnd: Schema.NullOr(Schema.DateTimeUtc),
  cancelAtPeriodEnd: Schema.Boolean,

  createdAt: Model.DateTimeInsertFromDate,
  updatedAt: Model.DateTimeUpdateFromDate,
}) {}
